<template>
  <div class="part-container">
    <div class="left-info">
      <TitleShow />
    </div>
    <div class="right-content">
      <div class="swiper-outer">
        <svg-icon icon-class="playDetails_930_512_border" class-name="border-svg" />
        <div class="swiper-padding">
          <div class="img-wrap">
            <img src="@/assets/images/playDetails/caseWeapon/case_1.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleShow from "./titleShow";
export default {
  components: { TitleShow },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>